import { cx } from "@/utils";

import styles from "./Toggle.module.css";

export type ToggleProps = {
  toggledLabel: string;
  untoggledLabel: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

const Toggle: React.FunctionComponent<ToggleProps> = ({
  toggledLabel,
  untoggledLabel,
  ...rest
}) => {
  return (
    <div className={styles.root} data-testid="insights-toggle">
      <label className={styles.label}>
        <input className={styles.input} {...rest} type="checkbox" />
        <div className={styles.inner}>
          <div className={cx(styles.option, styles.off)}>
            <span>{untoggledLabel}</span>
          </div>
          <div className={cx(styles.option, styles.on)}>
            <span>{toggledLabel}</span>
          </div>
        </div>
      </label>
    </div>
  );
};

export default Toggle;
